import { makeStyles } from '@material-ui/core';
import React from 'react';

import { spacings, TextSizesEnum } from '../../../theme';
import { PlexTypography } from '../../shared/primitives/PlexTypography';

interface Props {
  data?: {
    audience: number;
    impressions: number;
    clicks: number;
    commentsCount: number;
    reactionsCount: number;
  };
}

export const AnalyticsSummaryView = React.memo(({ data }: Props): React.ReactElement | null => {
  const classes = useStyles();

  if (!data) {
    return null;
  }

  const items = [
    {
      amount: data.audience,
      title: 'Audience',
    },
    {
      amount: data.impressions,
      title: 'Unique Impressions',
    },
    {
      amount: data.clicks,
      title: 'Unique Clicks',
    },
    {
      amount: data.commentsCount,
      title: 'Comments',
    },
    {
      amount: data.reactionsCount,
      title: 'Reactions',
    },
  ];

  return (
    <div className={classes.root}>
      <PlexTypography text={'Summary Stats:'} size={TextSizesEnum.Normal} />

      <div className={classes.statsContainer}>
        {items.map((item, i) => (
          <div key={i} className={classes.statColumn}>
            <PlexTypography text={item.amount.toString()} size={TextSizesEnum.XXLarge} />
            <PlexTypography text={item.title} size={TextSizesEnum.XXLarge} />
          </div>
        ))}
      </div>
    </div>
  );
});

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    margin: spacings.normal,
  },
  statsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: spacings.normal,
  },
  statColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: 180,
  },
}));
